// Outline
import VehicleOutline from "./vehicle-outline.svg?react";
import HouseOutline from "./house-outline.svg?react";
import MapOutline from "./map-outline.svg?react";
import CoinsOutline from "./coins-outline.svg?react";

// Filled
import Vehicle from "./vehicle-filled.svg?react";
import House from "./house-filled.svg?react";
import Map from "./map-filled.svg?react";
import Coins from "./coins-filled.svg?react";
import Menu from "./menu.svg?react";
import ChargingStation from "./charging-station.svg?react";

export const ICONS = {
  // Outline
  VehicleOutline,
  HouseOutline,
  MapOutline,
  CoinsOutline,

  // Filled
  Vehicle,
  House,
  Map,
  Coins,
  Menu,
  ChargingStation,
} as const;

export type IconId = keyof typeof ICONS;

export type IconProps = {
  icon: IconId;
  size?: string;
  color?: string;
  className?: string;
};

/**
 * This component makes it easier to use and modify svgs
 * @param icon selects the svg icon to render
 * @param color sets the css color for the svg
 * @returns a svg as an jsx element
 */
export default function Icon({
  icon,
  size = "24px",
  color = "currentColor",
  className,
}: IconProps) {
  const SvgIcon = ICONS[icon];

  return (
    <SvgIcon
      height={size}
      color={color}
      aria-hidden="true"
      className={className}
    />
  );
}
